import React, { useState } from "react";
import { Button, Modal, Input, Form, Col, message } from "antd";
import { useDispatch } from "react-redux";
import { deleteSchool } from "../../../_actions/user_actions";

const DeleteSchoolButton = ({ schoolId }) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form] = Form.useForm();

const handleDelete = async () => {
  try {
    const values = await form.validateFields();
    setConfirmLoading(true);

    if (values.password !== process.env.REACT_APP_DELETE_PASSWORD) {
      setConfirmLoading(false);
      throw new Error('Incorrect password');
    }

    await dispatch(deleteSchool({ _id: schoolId }));
    setConfirmLoading(false);
    setIsModalVisible(false);
    form.resetFields();
  } catch (error) {
    message.error("Validation failed: " + error);
  }
};

  return (
    <Col span={8} className="text-center">
      <Button
        type="primary"
        danger
        onClick={() => setIsModalVisible(true)}
      >
        Delete School
      </Button>

      <Modal
        title="Confirm Delete School"
        open={isModalVisible}
        onOk={handleDelete}
        onCancel={() => setIsModalVisible(false)}
        confirmLoading={confirmLoading}
        okText="Delete"
        okButtonProps={{ danger: true }}
      >
        <p>To confirm, please enter the delete password:</p>
        <Form form={form} layout="vertical">
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Password is required" }]}
          >
            <Input.Password placeholder="Enter the delete password" />
          </Form.Item>
        </Form>
      </Modal>
    </Col>
  );
};

export default DeleteSchoolButton;
